import { NgModule } from "@angular/core";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedLibraryModule } from "apps-module/app/shared-library/shared-library.module";

import { DatePickerComponent } from "./date-picker/date-picker.component";
import { DropdownFilterComponent } from "./dropdown-filter/dropdown-filter.component";
import { PaginationComponent } from "./pagination/pagination.component";
import { SearchBarComponent } from "./search-bar/search-bar.component";
import { SpinnerComponent } from "./spinner/spinner.component";

@NgModule({
    imports: [
        NgbDatepickerModule,
        SharedLibraryModule
    ],
    declarations: [
        DatePickerComponent,
        DropdownFilterComponent,
        PaginationComponent,
        SearchBarComponent,
        SpinnerComponent
    ],
    exports: [
        SharedLibraryModule,
        DatePickerComponent,
        DropdownFilterComponent,
        PaginationComponent,
        SearchBarComponent,
        SpinnerComponent
    ]
})
export class CommonComponentsModule {
}
